import {STATE_PROP_NAME} from './email-server-constants'

export const getEmailServerLocalDevState = state => state[STATE_PROP_NAME]
